module.exports = __webpack_public_path__ + "img/hic-eye-and-ear-diseases-female.8e3c70c3.png";